<template>
  <div class="cards">
    <div v-for="card in cards" class="grid-container" :key="card.id">
      <div class="issuer" @click="setDefault(card.id)">
        <div v-if="!card.icon">{{ card.issuer }}</div>
        <svg v-else width="50" height="35" viewBox="0 0 750 471"
             xmlns="http://www.w3.org/2000/svg" v-html="card.icon">
        </svg>
      </div>

      <div class="name">
        <div class="card-sm-data">
          <div class="pan-sm" @click="setDefault(card.id)">
            {{ card.masked_pan.substr(card.masked_pan.length - 7) }}
          </div>
          <div class="expiry-sm" @click="setDefault(card.id)">
            {{ formatExpDate(card.expiry_date) }}
          </div>
          <div v-if="card.is_default" class="default-card default-sm"></div>
          <div v-else class="default-sm" @click="setDefault(card.id)"></div>
          <div class="link link--orange remove-sm" @click="showCardRemoveConfirmation(card.id)">
            <i class="icon icon--cross"></i>
          </div>
        </div>
      </div>

      <div class="pan" @click="setDefault(card.id)">{{ card.masked_pan.substr(card.masked_pan.length - 7) }}</div>
      <div class="expiry" @click="setDefault(card.id)">{{ formatExpDate(card.expiry_date) }}</div>
      <div v-if="card.is_default" class="default-card default"></div>
      <div v-else class="default" @click="setDefault(card.id)"></div>
      <div class="link link--orange remove" @click="showCardRemoveConfirmation(card.id)">
        <i class="icon icon--cross"></i>
      </div>

      <!-- remove card confirmation modal -->

      <ConfirmationModal
        v-if="showConfirmationModal"
        @cancel="cancelCardRemove"
        @confirmed="removeCard()"
      >
        <h1 slot="header">{{ $t('common.deleting') }} </h1>
        <p slot="body">{{ $t('payment.confirm_delete') }}</p>
      </ConfirmationModal>

    </div>
  </div>
</template>

<script>

import ConfirmationModal from '../../common/ConfirmationModal';
import {mapGetters} from "vuex";

export default {
  components: {
    ConfirmationModal
  },
  props: ['cards'],
  computed: {
    ...mapGetters({
      showConfirmationModal: 'payment/cards/showConfirmationModal'
    })
  },
  data() {
    return {
      removeCardId: null
    }
  },
  methods: {
    setDefault(cardId) {
      this.$store.dispatch('payment/cards/setDefault', {card_id: cardId})
        .then(response => {
          if (response) {
            this.$store.dispatch('payment/cards/fetchUserCardList')
          }
        })
    },
    removeCard() {
      this.$store.dispatch('payment/cards/removeCard', {card_id: this.removeCardId})
        .then(response => {
          if (response) {
            this.$store.dispatch('payment/cards/fetchUserCardList')
          }
        })
    },
    cancelCardRemove() {
      this.removeCardId = null
      this.$store.dispatch('payment/cards/setShowConformationModal', false);
    },
    showCardRemoveConfirmation(cardId) {
      this.removeCardId = cardId
      this.$store.dispatch('payment/cards/setShowConformationModal', true);
    },
    formatExpDate(expDate) {
      return String(expDate).substring(0, 2) + '/' + String(expDate).substring(2, 4)
    }
  }
}

</script>

<style lang="scss" scoped>

@import '../../../styles/spinner';
@import '~styles/app.scss';
@import '../assets/styles/payment';

</style>



// WEBPACK FOOTER //
// src/components/payment/ui/Cards.vue